import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { catchError, forkJoin, map, of } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import { ApiService } from './modules/services/api.services';
import { AuthUtils } from './core/auth/auth.utils';
import { UserService } from './core/user/user.service';


export const initialDataResolver = () =>
{
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    const apiService = inject(ApiService);
    const authService = inject(AuthService);
    const _userService = inject(UserService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
        forkJoin({
            user: apiService.loadUser(),
            // urls: apiService.loadUrls()
        }).pipe(
            map(({ user }) => {   
                if (user.data) {
                    const userResponse = user.data[0]
                    const dataLocal = AuthUtils.getLocalStorage();
                    authService.accessToken = { t: dataLocal.t, u: userResponse?.id };
                    // authService.urls = urls;
                    let userData = userResponse;
                    _userService.user = userData;
                    // apiService.firebaseAuthentication(userData);
                }
    
                // Return combined user and urls data
                return { user };
            }),
            catchError(error => {
                console.error('Error occurred:', error);
                return of({ user: null, urls: null });
            })
        )
    ]);
};

    
